import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
const Redirect = () => {
  const router = useLocation();
  useEffect(() => {
    const path = router.pathname;
    if (path !== "/") {
      window.open(`https://linkforest.web.app${path}`, "_self");
    } else {
      window.open(`https://linkforest.web.app`, "_self");
    }
  }, [router]);

  return <div>Loading..</div>;
};

export default Redirect;
